import React from "react";

const ContactCard = ({ name, role, email, cell, socialLinks, imageSrc }) => {
  return (
    <div className="group relative w-full max-w-[638px] cursor-pointer overflow-visible select-none">
      
      {/* Background layer: Pushes out perfectly by 6px on hover */}
      <div className="absolute inset-0 bg-[#CC5E15] translate-x-0 translate-y-0 transition-all duration-300 group-hover:-translate-x-1.5 group-hover:translate-y-1.5 -z-10" />

      {/* Main Content Card: Shifts slightly up-right to meet the shadow seamlessly */}
      <div className="relative flex flex-col md:flex-row bg-white p-5 transition-transform duration-300 transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5 border border-transparent shadow-[0_0_15px_rgba(0,0,0,0.02)]">
        
        {/* Image Section: Changed aspect-square to aspect-[3/4] to match portrait dimensions perfectly */}
        <div className="w-full md:w-[38%] flex-shrink-0 bg-[#CC5E15] overflow-hidden aspect-[3/4]">
          <img
            src={imageSrc}
            alt={name}
            className="h-full w-full object-cover object-top font-sans text-xs" 
          />
        </div>

        {/* Right Side: Details Stack */}
        <div className="flex flex-col justify-between flex-grow mt-4 md:mt-0 md:ml-6 py-1 font-sans min-w-0">
          <div>
            {/* Role Header */}
            <h2 className="text-[24px] sm:text-[28px] font-extrabold font-barlow tracking-wide text-black uppercase leading-tight truncate">
              {role}
            </h2>
            {/* Member Name */}
            <p className="text-base text-gray-800 font-medium mt-0.5 mb-5 truncate">{name}</p>
            
            {/* Metadata Fields with Bottom Divider Accents */}
            <div className="space-y-2">
              
              {/* Clickable Email Section */}
              <div className="border-b border-gray-100 pb-1.5">
                <span className="block text-[10px] font-semibold font-montserrat tracking-wider text-gray-400 uppercase">EMAIL</span>
                {email ? (
                  <a 
                    href={`mailto:${email}`}
                    className="text-[13px] font-medium font-montserrat text-gray-700 block mt-0.5 truncate hover:text-[#CC5E15] transition-colors"
                  >
                    {email}
                  </a>
                ) : (
                  <span className="text-[13px] font-medium font-montserrat text-gray-400 block mt-0.5 italic">No email provided</span>
                )}
              </div>
              
              {/* Cell Section */}
              <div className="border-b border-gray-100 pb-1.5">
                <span className="block text-[10px] font-semibold font-montserrat tracking-wider text-gray-400 uppercase">CELL</span>
                <span className="text-[13px] font-medium font-montserrat text-gray-700 block mt-0.5 truncate">{cell || "—"}</span>
              </div>
              
              {/* Clickable Social Section */}
              <div className="border-b border-gray-100 pb-1.5">
                <span className="block text-[10px] font-semibold font-montserrat tracking-wider text-gray-400 uppercase">SOCIAL</span>
                <div className="text-[13px] font-medium font-montserrat text-gray-700 block mt-0.5 truncate space-x-1">
                  {socialLinks && socialLinks.length > 0 ? (
                    socialLinks.map((link, index) => (
                      <React.Fragment key={link.platform || index}>
                        <a
                          href={link.url}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="hover:text-[#CC5E15] transition-colors inline-block"
                        >
                          {link.platform}
                        </a>
                        {index < socialLinks.length - 1 && <span className="text-gray-400 select-none"> . </span>}
                      </React.Fragment>
                    ))
                  ) : (
                    <span className="text-gray-400 italic font-normal">No links available</span>
                  )}
                </div>
              </div>

            </div>
          </div>

          {/* Help Form Button */}
          <a
            href={`mailto:${email || "spirit@iitg.ac.in"}?subject=${encodeURIComponent(
              "Help Request — Campus Ambassador Program"
            )}&body=${encodeURIComponent(
              `Hi ${name || "team"},\n\nI need help with the Campus Ambassador Program.\n\n`
            )}`}
            className="mt-4 flex items-center gap-2 bg-[#F5E2D6] text-[#CC5E15] font-bold text-sm px-4 py-2.5 w-fit transition-all duration-300 hover:bg-[#EAD2C3]"
          >
            <svg className="w-4 h-4 shrink-0" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <path d="m4.93 4.93 4.24 4.24"/>
              <path d="m14.83 9.17 4.24-4.24"/>
              <path d="m14.83 14.83 4.24 4.24"/>
              <path d="m9.17 14.83-4.24 4.24"/>
              <circle cx="12" cy="12" r="4"/>
            </svg>
            <span className="tracking-wide">Help Form</span>
            <span className="text-base font-bold leading-none transform translate-y-[-1px]">→</span>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ContactCard;